<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            class="voip-peers-dialog"
            [hideOkButton]="!isAuthorized"
            [disabled]="!mapForm.form.valid"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' VOIP PEER'">

    <form #mapForm="ngForm" autocomplete="off">
        <mat-form-field class="fullWidth">
            <mat-label>Name</mat-label>
            <input matInput required [(ngModel)]="data.selectedItem.name" name="name">
            <mat-error>
                Name is <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <mat-form-field class="fullWidth">
            <mat-label>Peer Type</mat-label>
            <mat-select required [(ngModel)]="data.selectedItem.deviceType" name="deviceType">
                <mat-option *ngFor="let item of sipHeaderOptions" [value]="item">
                    {{item}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="fullWidth">
            <mat-label>CAC Profile</mat-label>
            <mat-select [(ngModel)]="data.selectedItem.cacProfileId" name="cacProfiles">
                <mat-option></mat-option>
                <mat-option *ngFor="let item of data.cacProfiles" [value]="item.value">
                    {{item.text}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="data.selectedItem.topologyGroups && data.selectedItem.topologyGroups.length > 0" class="fullWidth">
          <mat-label>Resource Groups</mat-label>
          <div class="resource-groups-names">
            <mat-chip-list aria-label="Resource Groups" disabled>
              <mat-chip *ngFor="let group of data.selectedItem.topologyGroups"
                        [selectable]="false" class="resource-groups-names-chip" title="{{group.name}}">
                {{group.name}}
              </mat-chip>
            </mat-chip-list>
          </div>
        </mat-form-field>
    </form>
</arm-dialog>
